<template>
  <div class="app-container">
    <div class="head-container">
      <div class="filter-container">
        <el-select
          v-model="query.activityId"
          clearable
          filterable
          size="small"
          placeholder="选择活动"
          class="filter-item"
          style="width: 280px; margin-right: 10px;"
        >
          <el-option
            v-for="item in activityOptions"
            :key="item.id"
            :label="(item.activityName || '') + ' [' + (item.activityCode || '') + ']'"
            :value="item.id"
          />
        </el-select>
        <el-input
          v-model="query.keyword"
          clearable
          size="small"
          placeholder="昵称/活动/UID"
          class="filter-item"
          style="width: 200px; margin-right: 10px;"
          @keyup.enter.native="loadList"
        />
        <el-button class="filter-item" size="mini" type="primary" icon="el-icon-search" @click="loadList">
          查询
        </el-button>
        <el-button class="filter-item" size="mini" icon="el-icon-refresh-left" @click="resetQuery">
          重置
        </el-button>
        <el-button
          class="filter-item"
          size="mini"
          type="success"
          icon="el-icon-download"
          @click="openExport"
        >
          导出参与活动数据
        </el-button>
      </div>
    </div>

    <el-table v-loading="loading" :data="list" size="small" style="width: 100%;">
      <el-table-column prop="id" label="ID" width="90" />
      <el-table-column prop="uid" label="用户UID" width="100" />
      <el-table-column prop="nickName" label="昵称" min-width="120" show-overflow-tooltip />
      <el-table-column prop="activityName" label="活动名称" min-width="140" show-overflow-tooltip />
      <el-table-column prop="activityCode" label="活动编码" min-width="140" show-overflow-tooltip />
      <el-table-column prop="storeName" label="门店" min-width="120" show-overflow-tooltip />
      <el-table-column prop="createTime" label="参与时间" width="170">
        <template slot-scope="scope">
          {{ formatDateTime(scope.row.createTime) }}
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      style="margin-top: 16px; text-align: right;"
      background
      layout="total, prev, pager, next, sizes"
      :current-page="query.page + 1"
      :page-size="query.size"
      :page-sizes="[10, 20, 50]"
      :total="total"
      @current-change="handlePageChange"
      @size-change="handleSizeChange"
    />

    <el-dialog
      title="导出参与活动数据"
      :visible.sync="exportDialog.visible"
      width="560px"
      :close-on-click-modal="false"
    >
      <el-form label-width="110px" size="small">
        <el-form-item label="选择活动" required>
          <el-select
            v-model="exportDialog.activityId"
            filterable
            clearable
            placeholder="请选择要导出的活动"
            style="width: 100%;"
          >
            <el-option
              v-for="item in activityOptions"
              :key="item.id"
              :label="(item.activityName || '') + ' [' + (item.activityCode || '') + ']'"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="导出范围">
          <el-radio-group v-model="exportDialog.rangeType">
            <el-radio label="ALL">全部</el-radio>
            <el-radio label="TODAY">今天</el-radio>
            <el-radio label="CUSTOM">指定时间范围</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="exportDialog.rangeType === 'CUSTOM'" label="时间段">
          <el-date-picker
            v-model="exportDialog.customRange"
            type="datetimerange"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%;"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini" @click="exportDialog.visible = false">取消</el-button>
        <el-button size="mini" type="primary" :loading="exportDialog.loading" @click="submitExport">
          确定导出
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import {
  exportSignsActivityUsers,
  fetchSignsActivityOptions,
  fetchSignsJoinRecords
} from '@/api/h5-admin-signs'

export default {
  name: 'H5AdminSignsJoinRecords',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      activityOptions: [],
      query: {
        page: 0,
        size: 20,
        keyword: '',
        activityId: null
      },
      exportDialog: {
        visible: false,
        loading: false,
        activityId: null,
        rangeType: 'ALL',
        customRange: []
      }
    }
  },
  created() {
    this.loadActivities()
    this.loadList()
  },
  methods: {
    formatDateTime(value) {
      if (value == null || value === '') return '-'
      const d = dayjs(value)
      return d.isValid() ? d.format('YYYY-MM-DD HH:mm:ss') : String(value)
    },
    findActivity(activityId) {
      if (activityId == null || activityId === '') return null
      const id = Number(activityId)
      return (this.activityOptions || []).find(item => Number(item.id) === id) || null
    },
    loadActivities() {
      fetchSignsActivityOptions()
        .then(res => {
          this.activityOptions = res.data || []
        })
        .catch(() => {
          this.activityOptions = []
        })
    },
    loadList() {
      this.loading = true
      const params = {
        page: this.query.page,
        size: this.query.size,
        keyword: this.query.keyword || undefined,
        activityId: this.query.activityId || undefined
      }
      fetchSignsJoinRecords(params)
        .then(res => {
          const data = res.data || {}
          this.list = data.content || []
          this.total = data.totalElements || 0
        })
        .finally(() => {
          this.loading = false
        })
    },
    resetQuery() {
      this.query.keyword = ''
      this.query.activityId = null
      this.query.page = 0
      this.loadList()
    },
    handlePageChange(page) {
      this.query.page = Math.max(page - 1, 0)
      this.loadList()
    },
    handleSizeChange(size) {
      this.query.size = size
      this.query.page = 0
      this.loadList()
    },
    openExport() {
      if (!(this.activityOptions && this.activityOptions.length)) {
        this.$message.warning('暂无可导出的活动，请确认账号已关联门店且门店下有活动')
        this.loadActivities()
        return
      }
      this.exportDialog = {
        visible: true,
        loading: false,
        activityId: this.query.activityId || null,
        rangeType: 'ALL',
        customRange: []
      }
    },
    async submitExport() {
      const form = this.exportDialog
      const activityId = form.activityId
      if (!activityId) {
        this.$message.warning('请选择要导出的活动')
        return
      }
      if (form.rangeType === 'CUSTOM') {
        const range = Array.isArray(form.customRange) ? form.customRange : []
        if (range.length !== 2 || !range[0] || !range[1]) {
          this.$message.warning('请选择完整时间段')
          return
        }
      }
      const params = { rangeType: form.rangeType || 'ALL' }
      if (form.rangeType === 'CUSTOM') {
        params.startTime = form.customRange[0]
        params.endTime = form.customRange[1]
      }
      form.loading = true
      try {
        const res = await exportSignsActivityUsers(activityId, params)
        const blob = res instanceof Blob
          ? res
          : new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        if (blob.type && blob.type.indexOf('application/json') >= 0) {
          const text = await blob.text()
          let msg = '导出失败'
          try {
            const json = JSON.parse(text)
            msg = (json && (json.msg || json.message)) || msg
          } catch (e) {
            // ignore
          }
          this.$message.error(msg)
          return
        }
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        const act = this.findActivity(activityId) || {}
        const activityName = (act.activityName || '活动').replace(/[\\/:*?"<>|]/g, '_')
        a.download = `${activityName}_参与活动数据_${new Date().getTime()}.xlsx`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(url)
        this.$message.success('导出成功')
        form.visible = false
      } catch (e) {
        this.$message.error('导出失败：' + ((e && e.message) || '未知错误'))
      } finally {
        form.loading = false
      }
    }
  }
}
</script>
